module.exports = __webpack_public_path__ + "static/media/disc.97e47ce3.png";